import { BILLING_CYCLE, billingCycleDependBasePlanTypeList, planTypes } from '@/common/constants';
import { getCartInfo } from "@/common/service/default-mapper";
import store from "@/store";

const usersLimit = { max: 99, min: 1 };

const pickInfo = (zschedPlan) => {
  const enableStandaloneCycleLimit = store.getters.enableStandaloneCycleLimit;
  const {
    // monthly
    zsched_yearly,
    yearly_hide,
    // yearly
    zsched_monthly,
    month_hide,
    // quarterly
    quarterly_hide,
    quarterly_plancode,
    quarterly_plantype,
    quarterly_amount,
    // two years
    two_years_hide,
    two_years_plancode,
    two_years_plantype,
    two_years_amount,
    // three years
    three_years_hide,
    three_years_plancode,
    three_years_plantype,
    three_years_amount,
  } = zschedPlan;
  const result = [];

  const cycleDepList = enableStandaloneCycleLimit ? billingCycleDependBasePlanTypeList : [];
  if(zsched_monthly && !month_hide) {
    const onlinePlan = zsched_monthly.prices.find(item => item.start <=1 && item.end >= 99);
    if(onlinePlan) {
      const amount = onlinePlan.price;
      const monthlyPlan = {
        type: planTypes.ZOOM_SCHEDULER,
        category: 'zsched',
        sub_type: 'zsched',
        plan_code: zsched_monthly.plan_code,
        amount: amount,
        cartInfo: getCartInfo(),
        billing_cycle: BILLING_CYCLE.MONTHLY,
        typeNameKey: 'billing.scheduler.title',
        planNameKey: 'billing.scheduler.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList: cycleDepList,
        ...usersLimit
      };
      result.push(monthlyPlan);
    }
  }
  if(zsched_yearly && !yearly_hide) {
    const onlinePlan = zsched_yearly.prices.find(item => item.start <=1 && item.end >= 99);
    if(onlinePlan) {
      const amount = onlinePlan.price;
      const yearlyPlan = {
        type: planTypes.ZOOM_SCHEDULER,
        category: 'zsched',
        sub_type: 'zsched',
        plan_code: zsched_yearly.plan_code,
        amount: amount,
        cartInfo: getCartInfo(),
        billing_cycle: BILLING_CYCLE.ANNUAL,
        typeNameKey: 'billing.scheduler.title',
        planNameKey: 'billing.scheduler.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList: cycleDepList,
        ...usersLimit
      };
      result.push(yearlyPlan);
    }
  }

  // smb billing cycle
  if (quarterly_plancode && quarterly_plantype && quarterly_amount && !quarterly_hide) {
    const onlinePlan = quarterly_amount.find(item => item.start <=1 && item.end >= 99);
    if (onlinePlan) {
      const quarterlyPlan = {
        type: planTypes.ZOOM_SCHEDULER,
        category: 'zsched',
        sub_type: 'zsched',
        plan_type: quarterly_plantype,
        plan_code: quarterly_plancode,
        amount: onlinePlan.price,
        cartInfo: getCartInfo(),
        billing_cycle: BILLING_CYCLE.QUARTERLY,
        typeNameKey: 'billing.scheduler.title',
        planNameKey: 'billing.scheduler.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList: cycleDepList,
        ...usersLimit
      };
      result.push(quarterlyPlan);
    }
  }

  if (two_years_plancode && two_years_plantype && two_years_amount && !two_years_hide) {
    const onlinePlan = two_years_amount.find(item => item.start <=1 && item.end >= 99);
    if (onlinePlan) {
      const quarterlyPlan = {
        type: planTypes.ZOOM_SCHEDULER,
        category: 'zsched',
        sub_type: 'zsched',
        plan_type: two_years_plantype,
        plan_code: two_years_plancode,
        amount: onlinePlan.price,
        cartInfo: getCartInfo(),
        billing_cycle: BILLING_CYCLE.TWO_YEARS,
        typeNameKey: 'billing.scheduler.title',
        planNameKey: 'billing.scheduler.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList: cycleDepList,
        ...usersLimit
      };
      result.push(quarterlyPlan);
    }
  }

  if (three_years_plancode && three_years_plantype && three_years_amount && !three_years_hide) {
    const onlinePlan = three_years_amount.find(item => item.start <=1 && item.end >= 99);
    if (onlinePlan) {
      const quarterlyPlan = {
        type: planTypes.ZOOM_SCHEDULER,
        category: 'zsched',
        sub_type: 'zsched',
        plan_type: three_years_plantype,
        plan_code: three_years_plancode,
        amount: onlinePlan.price,
        cartInfo: getCartInfo(),
        billing_cycle: BILLING_CYCLE.THREE_YEARS,
        typeNameKey: 'billing.scheduler.title',
        planNameKey: 'billing.scheduler.title',
        supportCoupon: true,
        dependBasePlanTypeList: [],
        billingCycleDependBasePlanTypeList: cycleDepList,
        ...usersLimit
      };
      result.push(quarterlyPlan);
    }
  }
  return result;
}

export default (planMapJSON) => pickInfo(planMapJSON.zsched_price_list || {});
